import React, { Component } from "react";

export default class PaymentInfo extends Component {
	render() {
		return (
			<div className="section-padding centered-text">
				<h4>{'Sign Up Instructions'}</h4>
				<div className="tiny-padding">
					<p>
						<span className="subheading">
							{'To sign up, please use the PayPal app on your smartphone to scan QR code below. Then email '}
						</span>
						<a href="mailto:nancy@pilatesavenue.com"><b>{'nancy@pilatesavenue.com'}</b></a>
						<span className="subheading">{' to request Zoom link. Purchase must be made at least 24 hours before scheduled class time.'}</span>
					</p>
				</div>
				<div className="tiny-padding">
					<img className="half-width" style={{maxWidth:"200px"}} src="/images/paypal.png" />
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/paymentInfo/index.js